<script lang="ts">
    import Card from "../containers/Card.svelte";
    import CardPack from "./CardPack.svelte";
    import Indexer from "./Indexer.svelte";
    import Manager from "../application/models/Manager.ts";
    import {onMount} from "svelte";

    export let block : Array<any>;
    export let manager : Manager;

    let focus = 0;
    let hovered = false;
    let tick = 0;

    function focusStepRight(){
        if(focus<block.length){focus++;}
        if(focus === block.length){focus = 0;}
    }

    function focusStepLeft(){
        if(focus>-1){focus--;}
        if(focus === -1){focus=block.length-1}
    }

    function arraySplit():Array<any> {
        let output = [];
        for(let i = 0; i < block.length; i++){
            if(i!==focus){output.push(block[i]);}
        }
        return output;
    }

    function setFocus(value){
        focus = value;
    }

    onMount(() => {
        const interval = setInterval(() => {
            tick++;
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    });
</script>

<div class="cardHolder pos"
     class:hover={hovered}
     on:mouseenter={()=>hovered=true}
     on:mouseleave={()=>hovered=false}>
    {#if block.length <= 5}
        <Card on:modalOpen manager={manager} cardData={block[focus]} position={0} focus={true}/>
        {#if block.length > 1}
            {#each arraySplit() as card,i}
                <Card on:modalOpen manager={manager} cardData={card} position={i+1} focus={false}/>
            {/each}
            <Indexer setFocus={setFocus} scale={arraySplit().length+1} focus={focus} passLeft={focusStepLeft} passRight={focusStepRight}/>
        {/if}
    {/if}
    {#if block.length > 5}
        <CardPack on:modalOpen cards={block} manager={manager} onMobile={false}/>
    {/if}
</div>

<style>
    .pos {position: relative;}
</style>